


const labels = {


  // Tool Tips
  refComponentSwitchButton: 'Use [Left Arrow] and [Right Arrow] keys or click to switch',
  propertyDuplicateSymbol: '+',
  propertyRemoveSymbol: '-',
  propertyDuplicateTip: 'Click to duplicate this property or press [Crtl and SHIFT +]',

}


export default labels;